import * as React from 'react';
import classNames from 'clsx';
import { isMobileOnly } from 'react-device-detect';

import '../styles/Link.css';

export interface ILinkProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  onPress?: (event?: React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.KeyboardEvent<HTMLAnchorElement>) => void;
  style?: React.CSSProperties;
  bold?: boolean;
}

type AnchorEvent = React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.KeyboardEvent<HTMLAnchorElement>;
type PressHandler = (event?: AnchorEvent) => void;

export const Link: React.FC<ILinkProps> = ({ href, bold, onPress, onClick, onKeyDown, ...props }) => {
  const handlePress: PressHandler = (event) => {
    if (onPress) {
      onPress(event);
    }
  };

  const handlePressProps: ILinkProps = {
    onClick: onClick
      ? (event) => {
        if (onClick) {
          onClick(event);
        }
        handlePress(event);
      }
      : handlePress,
    // handle enter and space as a trigger
    onKeyDown: (event) => {
      if (event.keyCode === 13 || event.key === ' ') {
        if (event.stopPropagation) {
          event.stopPropagation();
        }
        handlePress(event);
      }
      if (onKeyDown) {
        onKeyDown(event);
      }
    },
  };

  return (
    <a
      {...props}
      className={classNames('link', { 'link--bold': bold, 'link--mobile': isMobileOnly })}
      href={href}
      {...handlePressProps}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/Link.tsx